import { Alert, Field, Stack, Switch } from "@leylion/design-system";
import type { GiftCardReplacement } from "../api/client";
import { resolveLocalDateTime, localDateTimeErrorMessage, localTimeZoneHint } from "../shared/local-date-time";

export function giftReplacementInput(noExpiry: boolean, expiry: string, language: "ar" | "en"): GiftCardReplacement {
  if (noExpiry) return { noExpiry: true, expiresAt: null };
  const parsed = resolveLocalDateTime(expiry);
  if (parsed.error) throw new Error(localDateTimeErrorMessage(parsed.error, language));
  return { noExpiry: false, expiresAt: parsed.iso! };
}
export function GiftCardReplacementFields({ language, permitted, noExpiry, expiry, disabled, onNoExpiry, onExpiry }: {
  language: "ar" | "en"; permitted: boolean; noExpiry: boolean; expiry: string; disabled?: boolean;
  onNoExpiry: (value: boolean) => void; onExpiry: (value: string) => void;
}) {
  const ar = language === "ar";
  return <Stack><Alert tone="warning" title={ar ? "بطاقة الهدية الأصلية منتهية الصلاحية" : "The original gift card has expired"}>
    {ar ? "يُعاد الجزء المستحق إلى بطاقة بديلة. رصيد البطاقة القديم لا يُنقل." : "The refundable portion is returned on a replacement. The original expired balance is not transferred."}</Alert>
    {permitted ? <><Switch data-testid="gift-replacement-no-expiry" label={ar ? "دون انتهاء" : "No expiry"} checked={noExpiry} disabled={disabled} onChange={e => onNoExpiry(e.target.checked)} />
      {!noExpiry ? <Field data-testid="gift-replacement-expiry" label={ar ? "صلاحية البطاقة البديلة" : "Replacement expiry"} type="datetime-local" value={expiry} disabled={disabled} onChange={e => onExpiry(e.target.value)} /> : null}<small>{localTimeZoneHint(language)}</small></>
      : <Alert tone="info" title={ar ? "يتطلب تحديد الصلاحية صلاحية إدارة بطاقات الهدايا" : "Choosing validity requires gift card management permission"} />}
  </Stack>;
}
